module.exports = __webpack_public_path__ + "static/media/grid-item-a2.4e422c52.png";